import React, { useEffect, useState } from "react";

import { makeStyles, TextField } from "@material-ui/core";
import CalendarToday from "@material-ui/icons/CalendarToday";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import { LinkAssetType } from "../../../../entities/LinkAssetType";
import { FieldValidationError, ValidationHelper } from "../../../../services/server/ServerResponses";
import { LibraryItem } from "../../../../entities/LibraryItem";

const useStyles = makeStyles(() => ({
    editInput: {
        fontSize: 12,
        width: 244,
        marginBottom: 4,
        color: "#202124",
        fontFamily: "Roboto, Helvetica"
    },
    dateInput: {
        "& div:first-of-type": {
            "& div:first-of-type": {
                fontSize: 12,
                lineHeight: 4,
            },
        },
    },
}));

interface Props {
    item: LibraryItem;
    errors: FieldValidationError[];
    onFormUpdate: (data:EditFormRequest) => void
}

export interface EditFormRequest {
    title: string;
    templateDescription?: string;
    preachDate: Date | null;
    locationPreached?: string
    scriptureReferences?: string
    url?: string
}

export function EditForm(props:Props){
    const { errors, item } = props;
    const classes = useStyles();
    const [formData, setFromData] = useState<EditFormRequest>({
        title: item.name,
        templateDescription: item.templateDescription,
        preachDate: item.datePreached ?? null,
        locationPreached: item.locationPreached,
        scriptureReferences: item.scripture ?? "",
        url: item.linkUrl
    })
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { props.onFormUpdate(formData) }, [formData])

    return (
        <>
            <TextField
                error={ValidationHelper.isFieldInError(errors, "Name")}
                placeholder="Title"
                className={classes.editInput}
                value={formData.title}
                onChange={(e) => setFromData({ ...formData, title: e.currentTarget.value })}
                inputProps={{
                    style: { fontSize: 12 },
                    "aria-label": "Name",
                }}
                helperText={ValidationHelper.getFieldErrorSummary(errors, "Name")}
            />
            {item.isTemplate && (
                <TextField
                    error={ValidationHelper.isFieldInError(errors, "TemplateDescription")}
                    placeholder="Description"
                    className={classes.editInput}
                    value={formData.templateDescription}
                    onChange={(e) => setFromData({ ...formData, templateDescription: e.currentTarget.value })}
                    inputProps={{
                        style: { fontSize: 12 },
                        "aria-label": "TemplateDescription",
                    }}
                    helperText={ValidationHelper.getFieldErrorSummary(errors, "TemplateDescription")}
                />
            )}
            {!item.isTemplate && (
                <>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                            style={{ width: 244}}
                            name="date-input"
                            placeholder="Preach Date"
                            clearable
                            value={formData.preachDate}
                            onChange={(date) => setFromData({ ...formData, preachDate: date ? new Date(date.setHours(0,0,0,0)) : null})}
                            InputProps={{
                                endAdornment: <CalendarToday style={{color: "rgba(0, 0, 0, 0.54)", fontSize: 20}} />
                            }}
                            inputProps={{
                                style: { fontSize: 12 },
                                value: formData.preachDate?.toLocaleDateString([], { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' }) ?? "",
                            }}
                        />
                    </MuiPickersUtilsProvider>
                    <TextField
                        error={ValidationHelper.isFieldInError(errors, "LocationPreached")}
                        placeholder="Location"
                        className={classes.editInput}                
                        value={formData.locationPreached}
                        onChange={(e) => setFromData({ ...formData, locationPreached: e.currentTarget.value })}
                        inputProps={{
                            style: { fontSize: 12 },
                            "aria-label": "Location",
                        }}
                        helperText={ValidationHelper.getFieldErrorSummary(errors, "LocationPreached")}
                    />
                    <TextField
                        error={ValidationHelper.isFieldInError(errors, "ScriptureReferences")}
                        placeholder="Scripture"
                        className={classes.editInput}
                        value={formData.scriptureReferences}
                        onChange={(e) => setFromData({ ...formData, scriptureReferences: e.currentTarget.value })}
                        inputProps={{
                            style: { fontSize: 12 },
                            "aria-label": "Scripture",
                        }}
                        helperText={ValidationHelper.getFieldErrorSummary(errors, "ScriptureReferences")}
                    />
                    {item.linkType && item.linkType === LinkAssetType.General && (
                        <TextField
                            error={ValidationHelper.isFieldInError(errors, "Url")}
                            placeholder="Url"
                            className={classes.editInput}
                            value={formData.url}
                            onChange={(e) => setFromData({ ...formData, url: e.currentTarget.value })}
                            inputProps={{
                                style: { fontSize: 12 },
                                "aria-label": "Url",
                            }}
                            helperText={ValidationHelper.getFieldErrorSummary(errors, "Url")}
                        />
                    )}
                </>
            )}
        </>
    )
}